import React, { FC } from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { Skeleton } from 'src/common';
import AccessControlList from './AccessControlList';
import classNames from 'classnames';
import { useActiveInboxState } from 'src/models/callOffs/hooks';
import RenameInboxForm from './RenameInboxForm';

export const InboxPreview: FC = () => {
  const [currentInbox] = useActiveInboxState();

  const { t } = useTranslation();

  const accessToEdit = !!currentInbox?.accessToEdit;

  const isLoading = false;

  return isLoading ? (
    <Skeleton active loading />
  ) : (
    <>
      {currentInbox && (
        <>
          <h2 className={classNames(styles.title, { [styles.disabled]: !accessToEdit })}>
            {accessToEdit ? `${t('Common.edit')} ${currentInbox.inboxName}` : currentInbox.inboxName}
          </h2>
          <RenameInboxForm currentInbox={currentInbox} accessToEdit={accessToEdit} />
          <AccessControlList currentInbox={currentInbox} readOnly={!accessToEdit} />
        </>
      )}
    </>
  );
};

export default InboxPreview;
